import { BaseViewChangeSate } from "../BaseViewChangeState";
import { DropdownProps } from "../DropdownProps";
import { EMPTY_RESUME_SG_CHARGE_ENTITY, ResumeSGChargeEntity } from "domain/entity/ResumeSGCharge/ResumeSGChargeEntity";
import { EMPTY_RESUME_SG_CHARGE_SEARCH_CRITERIA, ResumeSGChargeSearchCriteria } from "domain/entity/ResumeSGCharge/ResumeSGChargeSearchCriteria";

export interface ResumeSGChargeModelDropdownOptions {
    consortiumCodeDropdownOptions: DropdownProps[],
    chargeTypeDropdownOptions: DropdownProps[],
    subChargeTypeDropdownOptions: { [key: string]: DropdownProps[] },
}
export interface ResumeSGChargeModelViewChangeState extends BaseViewChangeSate {
}

export interface ResumeSGChargeModel {
    isLoading: boolean,
    isShowEditPanel: boolean,
    isShowSearchPanel: boolean,
    dynamicOptions: ResumeSGChargeModelDropdownOptions,
    resumeSGChargeList: ResumeSGChargeEntity[],
    selectedRows: ResumeSGChargeEntity[],
    currentRow: ResumeSGChargeEntity,
    currentEditRow: ResumeSGChargeEntity,
    searchCriteria: ResumeSGChargeSearchCriteria,
    forceRefresh: boolean,
    isSearchLoading: boolean,
}

export const EMPTY_RESUME_SG_CHARGE_MODEL: ResumeSGChargeModel = {
    isLoading: false,
    isShowEditPanel: false,
    isShowSearchPanel: false,
    dynamicOptions: {
        consortiumCodeDropdownOptions: [],
        chargeTypeDropdownOptions: [],
        subChargeTypeDropdownOptions: {}
    },
    resumeSGChargeList: [],
    selectedRows: [],
    currentRow: { ...EMPTY_RESUME_SG_CHARGE_ENTITY },
    currentEditRow: { ...EMPTY_RESUME_SG_CHARGE_ENTITY },
    searchCriteria: { ...EMPTY_RESUME_SG_CHARGE_SEARCH_CRITERIA },
    forceRefresh: false,
    isSearchLoading: true,
}